<template>
  <router-view v-if="routedVideo" />
  <template v-else>
    <transition-fade :duration="500" appear>
      <div>
        <box-generic
          :header="`${activeVolume?.title} / ${activeSeason?.issueNumber}`"
          :header-class="computedHeaderClass"
          :wStretch="true"
        >
          <ul
            v-if="activeSeasonContentForSchoolLevel?.videos?.length"
            id="video-list"
            class="flex flex-wrap justify-center max-h-[calc(100vh_-_209px)] overflow-y-auto"
          >
            <video-preview
              v-for="video in activeSeasonContentForSchoolLevel.videos"
              :key="video.slug"
              is="li"
              :video="video"
              :to="{
                name: 'FilmListVideoPlayer',
                params: {
                  ...route.params,
                  videoSlug: video.slug,
                },
              }"
              class="rounded-[3.5rem]"
            />
          </ul>
          <div v-else class="flex h-full justify-center items-center">
            <box-generic header="Geen materiaal">
              <p class="mt-3 leading-relaxed">
                In deze aflevering zijn er geen filmpjes beschikbaar.<br />
                U kunt altijd filmpjes vinden in het
                <router-link-button :to="{ name: 'FilmArchive' }" class="my-1">
                  Filmarchief</router-link-button
                >.
              </p>
            </box-generic>
          </div>
        </box-generic>
        <MediaFilmCircle
          class="pointer-events-none absolute top-0 right-0 translate-x-[-20%] translate-y-[20%]"
          :color="
            activeSeasonContentForSchoolLevel.schoolLevel.slug === 'onderbouw'
              ? '#127b5d'
              : '#6c44a5'
          "
        />
        <MediaFilmLine
          class="pointer-events-none absolute bottom-0 right-0 translate-x-[2%] translate-y-[-5%]"
          :color="
            activeSeasonContentForSchoolLevel.schoolLevel.slug === 'onderbouw'
              ? '#127b5d'
              : '#6c44a5'
          "
        />
      </div>
    </transition-fade>
  </template>
</template>

<script>
import { mapState, mapGetters } from "vuex";

import { RouterView } from "vue-router";

import BoxGeneric from "../../../../components/content/BoxGeneric.vue";
import RouterLinkButton from "../../../../components/content/RouterLinkButton.vue";
import VideoPreview from "../../../../components/content/media/VideoPreview.vue";
import TransitionFade from "../../../../components/magic/TransitionFade.vue";
import MediaFilmCircle from "../../../../components/content/svg/MediaFilmCircle.vue";
import MediaFilmLine from "../../../../components/content/svg/MediaFilmLine.vue";

import findBySlug from "../../../../store/getters/resolve/find-by-slug";

export default {
  name: "FilmList",
  components: {
    BoxGeneric,
    RouterView,
    RouterLinkButton,
    TransitionFade,
    VideoPreview,
    MediaFilmLine,
    MediaFilmCircle,
  },
  computed: {
    ...mapState(["route"]),
    ...mapGetters([
      "activeVolume",
      "activeSeason",
      "activeSeasonContentForSchoolLevel",
      "routedVideo",
    ]),
    computedHeaderClass() {
      const slug = this.activeSeasonContentForSchoolLevel?.schoolLevel?.slug;
      return slug ? `title-block title-block-${slug}` : "title-block";
    },
  },
};
</script>
